import vuex from "vuex";
import localStorage from "../../helper/localStorage";
import http from "../../helper/http";

/**
 * 用户登录数据以及状态管理store
 */

const state = {
    menuListForDev: [],
    leftMenuListForDev: []
}

const getters = {
    menuListForDev: async () => {
        if (state.menuListForDev.length == 0)
            await mutations.updateStateData();
        return state.menuListForDev;
    },
    leftMenuListForDev: async () => {
        if (state.menuListForDev.length == 0)
            await mutations.updateStateData();
        return state.leftMenuListForDev;
    }
}

const actions = {
    async updateStateData({ commit }) {
        commit('updateStateData');
    }
}

const mutations = {
    updateStateData: async () => {
        let menuList = await http.get("/menu/getmenulist");
        menuList = menuList.filter(a => a.id != 46);
        state.menuListForDev = menuList;
        state.leftMenuListForDev = menuList[0];
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/menu.js